import { orchestration } from '~/config/public';
import axios from '~/helpers/orchestration/axiosWithAuthHandling';
import { getRecaptchaHeaders } from '~/helpers/recaptcha';

export const submitPartnerLeasingForm = ({
  fullName,
  email,
  phoneNumber
}: {
  fullName: string;
  email: string;
  phoneNumber: string;
}) => {
  return axios.post(
    `${orchestration.url}/common/form-submission`,
    {
      formSubmission: {
        fullName: fullName,
        email: email,
        phoneNumber: phoneNumber
      }
    },
    {
      responseType: 'json'
    }
  );
};

export type LeasingInterest = {
  fullName: string;
  email: string;
  phoneNumber: string;
  recordId: string;
};

export const submitLeasingInterest = async (
  provider: string,
  { fullName, email, phoneNumber, recordId }: LeasingInterest
) => {
  return axios.post(
    `${orchestration.url}/common/leasing-interest/${encodeURIComponent(
      provider
    )}`,
    { leasingInterest: { fullName, email, phoneNumber, recordId } },
    {
      responseType: 'json',
      headers: await getRecaptchaHeaders()
    }
  );
};
